export enum InitiativeCategory {
  Intergovernmental = 'Intergovernmental or supranational',
  NationalStrategy = 'National – Strategy',
  NationalGovernance = 'National – AI governance bodies or mechanisms',
  NationalGeneral = 'National – AI policy initiatives, regulations, guidelines, standards and programmes or projects'
}

export enum InitiativeMainCategory {
  Intergovernmental = 'Intergovernmental or supranational',
  National = 'National'
}
